"use client";
import React, { ChangeEvent, ForwardedRef, forwardRef } from "react";

import BaseInput, { BaseInputProps } from "@/ui/Forms/BaseInput";

interface FormPhoneInputProps extends BaseInputProps {
  onValueChange?: (value: string) => void;
}

const FormPhoneInput = (
  { onValueChange, onChange, value, ...props }: FormPhoneInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.replace(/[^\d+]/g, "");

    onValueChange?.(value);
    onChange?.(event);
  };

  return (
    <BaseInput
      ref={ref}
      type="tel"
      inputMode="tel"
      value={value}
      onChange={handleChange}
      {...props}
    />
  );
};

export default forwardRef(FormPhoneInput);
